const accordions = (postType) => (
    `... on ${postType}_Components_Components_Accordions {
        content
        fieldGroupName
        displayType
        listFormat
        cta {
            target
            title
            url
        }
        accordions {
            content
            cta {
                target
                title
                url
            }
            title
            icon {
                altText
                title
                mimeType
                sourceUrl
            }
        }
        image {
            altText
            title
            sizes(size: LARGE)
            sourceUrl(size: LARGE)
            srcSet(size: LARGE)
        }
        title
        settings {
            theme
            showComponentTitle
            componentTitle
            spacing
        }
    }`
);

export default accordions;
